import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      retryCount: 0,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    });
    // You can log the error to an error reporting service here
    console.error('Error caught by boundary:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState(prevState => ({
      hasError: false,
      error: null,
      errorInfo: null,
      retryCount: prevState.retryCount + 1,
    }));
    // Trigger the fallback retry mechanism
    this.props.onRetry?.();
  };

  render() {
    const { hasError, error, retryCount } = this.state;
    const { fallback, children } = this.props;

    if (hasError) {
      // If custom fallback is provided, use it
      if (fallback) {
        return fallback(error, this.handleRetry);
      }

      // Default error UI
      return (
        <div className="error-boundary-container text-center py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="error-content bg-light p-4 rounded shadow-sm">
                  <h2 className="text-danger mb-4">
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    Temporary Service Disruption
                  </h2>
                  <p className="text-muted mb-4">
                    We're experiencing technical difficulties accessing some content. 
                    Our team has been notified and is working to resolve this issue.
                  </p>
                  {retryCount < 3 && (
                    <button
                      className="btn btn-primary mb-3"
                      onClick={this.handleRetry}
                    >
                      <i className="fas fa-sync-alt me-2"></i>
                      Try Again
                    </button>
                  )}
                  <div className="mt-3">
                    <small className="text-muted">
                      If the problem persists, please contact our support team at{' '}
                      <a href="mailto:support@gisqatar.org.qa">
                        support@gisqatar.org.qa
                      </a>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.func,
  onRetry: PropTypes.func,
};

export default ErrorBoundary; 